<template>
    <b-button
        variant="secondary"
        @click.stop="confirmar()"
        v-if="$temAcessoView('CTRLACS-APP-04')"
        class="mr-2"
    >
        <span> <i class="fa fa-refresh mr-2"></i> Recriar Token</span>
    </b-button>
</template>

<script>
import AplicacoesServicos from './AplicacoesServicos'

export default {
    props: {
        aplicacao: {
            type: Object
        }
    },

    methods: {
        confirmar() {
            this.$swal({
                title: 'Token de Acesso',
                html: `Confirma a recriação do token de acesso da aplicação <b>${this.aplicacao.codigo}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.recriar()
                }
            })
        },

        recriar() {
            this.$store.dispatch('addRequest')
            AplicacoesServicos.recriarToken(this.aplicacao).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Token recriado com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarAplicacao', response.data)
                        this.$store.dispatch('setRecarregar', true)
                    } else {
                        this.$toast.success(
                            'Falha ao recriar token',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
